import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from '../../core/service'

export const getAlertHighlight = createAsyncThunk(
  'portfolio/summary/getAlertHighlight',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getAlertHighlight(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCompanyAlerts = createAsyncThunk(
  'portfolio/summary/getCompanyAlerts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getCompanyAlerts(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
